export default __webpack_public_path__ + "static/media/image11.26530863.png";